import { Box, Stack, styled } from '@mui/material';

export const StatsGrid = styled(Stack)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gridTemplateRows: 'repeat(2, auto)',
  gridAutoFlow: 'column',
  justifyContent: 'space-between',
  alignContent: 'space-between',
  alignItems: 'center',
  gap: '48px',
  width: '100%',
  height: '100%',
  paddingBottom: '16px',

  [theme.breakpoints.down('lg')]: {
    gap: '24px',
  },

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gridTemplateRows: 'auto',
    gridAutoFlow: 'row',
    gap: '20px',
  },
}));

export const StatsItemContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  width: '100%',
  minWidth: 0,
  height: '100%',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '4px',
  },
}));

export const StatsInfo = styled(Stack)({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  minWidth: 0,
  overflowWrap: 'anywhere',
});
